import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import {
  useProposalFormConfig,
  ProposalFormProps,
} from "../../../components/UniversalForm/entityForms";

const ProposalForm: React.FC<ProposalFormProps> = (props) => {
  const config = useProposalFormConfig(props);
  return (
    <>
      <style>{`
        .proposal-form-responsive {
          max-width: 615px;
          margin: 0 auto;
        }

        @media (min-width: 1024px) {
          .proposal-form-responsive {
            max-width: 922px;
          }
        }
      `}</style>
      <div className="proposal-form-responsive">
        <UniversalForm config={config} />
      </div>
    </>
  );
};

export default ProposalForm;
